import {
	mapActions
} from "vuex";
import moment from "moment";
import _ from "lodash";
import getMvcUrl from "../../utils/mvcUrlUtil.js";
export default {
	components: {
	},
	data() {
		return {
			permissions: {
				toShip: false,
				deal_query: false
			},
			loading: false, 
			statusList:[
				{
					value:-1,
					label:'全部'
				},
				{
					value:0,
					label:'待处理'
				},
				{
					value:1,
					label:'已处理'
				},
				{
					value:2,
					label:'已取消'
				},
				{
					value:3,
					label:'异常'
				}
				],
			qeuryForm: {
				orderId:null,
				srcAddr:null,
				destAddr:null,
				outerOrderId:null,
				status:0,
				srcPlanArriveTm:[],
				pageNum: 1,
				pageSize: 10,
			}, 
			addVehicleLengthList: [],
			vehicleLengthList: [],
			vehicleTypeList: [],
			vehicleLength: [],
			vehicleLengthMap: {},
			total: 0,
			table: []
		}
	},
	methods: {
		...mapActions([
			'queryCarTypeListApi',
			'getWaitHandleOrderListApi',
			'getWaitHandleOrderByIdApi'
		]), 
		onAddAddress() {
			this.addAddressVisible = true
		}, 
		queryCarTypeList() {
			this.vehicleTypeList = [];
			this.vehicleLengthMap = {};
			this.queryCarTypeListApi({}).then(res => {
				let vehicleTypeMapLens = res.typeMapLens;
				//初始化车型车长条件下拉框
				if (vehicleTypeMapLens) {
					for (let i = 0; i < vehicleTypeMapLens.length; i++) {
						this.vehicleTypeList.push({
							'value': vehicleTypeMapLens[i].plVehicleCode,
							'label': vehicleTypeMapLens[i].plVehicleType
						});
						this.vehicleLengthMap[vehicleTypeMapLens[i].plVehicleCode] = vehicleTypeMapLens[i].lens;
					}
				}
			})
		}, 
		jumpOrder(rowObj) {
			let that = this;
			let params = {};
			params.id = rowObj.id;
			this.getWaitHandleOrderByIdApi(params).then(res => {
				if(res.status!=0 && res.status!=3){
					that.$message({
						type: "error",
						message: '该订单状态为已处理或已取消,不允许发货'
					});
					return;
				}
				let row = {};
				row.id = rowObj.id;
				row.systemCode = rowObj.systemCode;
				row.cargoVolume = res.cargoVolume;
				row.cargoInfo = res.cargoType;
				row.cargoWeight = res.cargoWeight;
				row.quantity = res.cargoNum;
				row.outerOrderId = res.outerOrderId;
				row.totalLineDistance = res.lineDistance;
				row.comment = res.comment;
				row.vehicleType = res.vehicleType;
				row.vehicleLength = res.vehicleLength+'';
				row.expectedPrice = res.expectedPrice;
				
				//不需要回单
				if (res.needReceipt == 2) {
					row.needReceipt = 1;
				} else {
					row.receiptType = res.receiptType;
					// 电子回单
					if (row.receiptType == 1) {
						row.needReceipt = 2;
					}
					// 电子+纸质回单
					if (row.receiptType == 2) {
						row.needReceipt = 3;
						row.receiptAddress = res.receiptAddress;
						row.receiptName = res.receiptName;
						row.receiptPhone = res.receiptPhone;
					}
				}
				
				let start = res.passZoneResponseList[0];
				let end = res.passZoneResponseList[res.passZoneResponseList.length-1];
				row.start={
					addrDetail:start.addrDetail,
					orderPlacerName:start.contactName,
					planArriveTm:this.formatTm(start.planArriveTm),
					orderPlacerPhone:start.contactPhone,
					planSendtm:this.formatTm(start.planDepartTm),
					sortNum:start.sortNum,
					jobType:start.jobType,
					coordinate:start.coordinate,
					cityCode:start.cityCode,
					cityName:start.cityName
				};
				row.end={
					addrDetail:end.addrDetail,
					orderPlacerName:end.contactName,
					planArriveTm:this.formatTm(end.planArriveTm),
					orderPlacerPhone:end.contactPhone,
					planSendtm:this.formatTm(end.planDepartTm),
					sortNum:end.sortNum,
					jobType:end.jobType,
					coordinate:end.coordinate,
					cityCode:end.cityCode,
					cityName:end.cityName
				};
				if(res.passZoneResponseList.length>2){
					row.stops = [];
					for(let i = 1;i<res.passZoneResponseList.length-1;i++){
						row.stops.push(
						{
							addrDetail:res.passZoneResponseList[i].addrDetail,
							orderPlacerName:res.passZoneResponseList[i].contactName,
							planArriveTm:this.formatTm(res.passZoneResponseList[i].planArriveTm),
							orderPlacerPhone:res.passZoneResponseList[i].contactPhone,
							planSendtm:this.formatTm(res.passZoneResponseList[i].planDepartTm),
							sortNum:res.passZoneResponseList[i].sortNum,
							jobType:res.passZoneResponseList[i].jobType,
							coordinate:res.passZoneResponseList[i].coordinate,
							cityCode:res.passZoneResponseList[i].cityCode,
							cityName:res.passZoneResponseList[i].cityName
						}
						);
					}
				}
				window.sessionStorage.setItem('waitHandleOrderParams', JSON.stringify(row));
				this.$router.push("/manage/Shipments");
			}).catch(e => {
				if (e && e.succ === 'fail' && e.msg) {
					this.$message({
						type: "error",
						message: e.msg
					});
				}
			}).finally(() => {
				this.saveLoading = false;
			});
		},
		getWaitHandleOrderList() {
			this.loading = true;
			this.table = [];
			let params = {};
			params.pageNum = this.qeuryForm.pageNum;
			params.pageSize = this.qeuryForm.pageSize;
			params.orderId = this.qeuryForm.orderId;
			params.srcAddr = this.qeuryForm.srcAddr;
			params.destAddr = this.qeuryForm.destAddr;
			params.outerOrderId = this.qeuryForm.outerOrderId;
			params.status = this.qeuryForm.status;
			if(params.status==-1){
				params.status = null;
			}
			if(this.qeuryForm.srcPlanArriveTm.length>0){
				params.srcPlanArriveTmStart = this.qeuryForm.srcPlanArriveTm[0];
				params.srcPlanArriveTmEnd = this.qeuryForm.srcPlanArriveTm[1];
			}
			
			this.getWaitHandleOrderListApi(params).then(res => {
				this.table = res.rows;
				this.total = res.totalCount;
			}).catch(e => {
				if (e && e.succ === 'fail' && e.msg) {
					this.$message({
						type: "error",
						message: e.msg
					});
				}
			}).finally(() => {
				this.loading = false;
			});
		},
		onReset() {
			Object.assign(this.qeuryForm, this.$options.data().qeuryForm);
		},
		onSearch() {
			this.qeuryForm.pageNum = 1;
			this.getWaitHandleOrderList();
		},
		onSizeChange() {},
		onCurrentChange(val) {
			this.qeuryForm.pageNum = val;
			this.getWaitHandleOrderList();
		},
		mapVehicle(code) {
			for (let i = 0; i < this.vehicleTypeList.length; i++) {
				if (this.vehicleTypeList[i].value == code) {
					return this.vehicleTypeList[i].label;
				}
			}
			return code;
		},
		mapStatus(code){
			if(code == 0){
				return '待处理';
			}
			if(code == 1){
				return '已处理';
			}
			if(code == 2){
				return '已取消';
			}
			if(code == 3){
				return '异常';
			}
			return code;
		},
		formatTm(v) {
			if (v) {
				return moment(new Date(v)).format("YYYY-MM-DD HH:mm:ss");
			}
			return null;
		},
		formatOrderTm(v) {
			if (v) {
				return moment(new Date(v)).format("YYYY-MM-DD HH:mm");
			}
			return null;
		}
	},
	watch: {
		
	},
	computed: {},
	mounted() {
		this.getWaitHandleOrderList();
	},
	created() {
		this.queryCarTypeList();
		this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
	}
}
